import React from "react";
import { Link } from "react-router-dom";
import DesafiosTabs from "../../components/DesafiosTabs";

import "./styles.css";

import aderezos from "../../assets/icono_aderezos.png";
import culinarios from "../../assets/icono_culinarios.png";
import infusiones from "../../assets/icono_infusiones.png";
import postres from "../../assets/icono_postres.png";
import personal_care from "../../assets/icono_personal-care.png";
import home_care from "../../assets/icono_home-care.png";

function getIcono(training) {
  var icono = culinarios;
  switch (training.icon) {
    case "aderezos": icono = aderezos; break;
    case "culinarios": icono = culinarios; break;
    case "infusiones": icono = infusiones; break;
    case "postres": icono = postres; break;
    case "personal": icono = personal_care; break;
    case "home": icono = home_care; break;
    default: icono = culinarios; break;
  }
  return icono;  
}

const Render = (props, context) => {
  return (
    <section className="desafios panel int pbxl">
      <div className="container">
        <h1 className="avenirBK violet horizontalCenter ">Desafíos</h1>
        <DesafiosTabs />
        <ul className="panelUl boxOdd horizontal clearfix mha">
          {props.trainings.map(training => (
            training.historical <= 0 &&
            <li className="box borderBox round" key={training.id}>
              <div className="pRel borderBox clearfix round">
                <div className="img mask">
                  <img
                    src={getIcono(training)}
                    alt={training.name}
                    className="displayBlock horizontalCenter"
                  />
                </div>
                <div className="textContainer"><h2 className="mbs avenirL violet horizontalCenter ptm pbm">{training.name}</h2></div> 
                <p className="nivel ptl horizontalCenter mbn">
                  Capacitación {training.completed ? "100" : "0"}%
                </p>
                <div className="footer bgNone horizontalAroundFlex roundBottom">
                  <p className="titulo violet bold alignCenter width33">
                    Jugá por:
                  </p>
                  <p className="cifra man avenirBK violet upperCase alignCenter verticalCenterFlex width33">
                    {training.points} <span className="avenirL">PUNTOS</span>
                  </p>
                  <div className="width33 horizontalCenterFlex">
                    <Link
                      to={`/capacitaciones/${training.id}`}
                      className={`capIniciar ${
                        training.completed ? "capCompleta" : "capIncompleta"
                      } displayBlock indentedText`}
                    >
                      Iniciar Capacitación
                    </Link>
                  </div>
                  
                </div>
              </div>
            </li>
          ))}
        </ul>

        <h1 key="desafiosTit" className="avenirBK violet horizontalCenter mbl ">Capacitaciones históricas</h1>
        <ul className="panelUl boxOdd horizontal clearfix mha mtl">

          {props.trainings.map(training => (
            training.historical > 0 &&
              <li className="box borderBox round" key={training.id}>
              <div className="pRel borderBox clearfix round" style={{'minHeight': 'unset'}}>
                <div className="img mask" style={{'backgroundColor':'#02417b'}}>
                  <img
                    src={getIcono(training)}
                    alt={training.name}
                    className="displayBlock horizontalCenter"
                  />
                </div>
                <div className="textContainer" style={{'backgroundColor':'#02417b'}}> <h2 className="mbs avenirL violet horizontalCenter ptm pbm" style={{'borderBottom':'#02417b'}}>{training.name}</h2></div>
                
                <div className="footer bgNone horizontalAroundFlex roundBottom">
                <p className="nivel horizontalCenter mbn">
                  Capacitación {training.completed ? "100" : "0"}%
                </p>
               
                <div className="width33 horizontalCenterFlex">
                    <Link
                      to={`/capacitaciones/${training.id}`}
                      className={`capIniciar ${
                        training.completed ? "capCompleta" : "capIncompleta"
                      } displayBlock indentedText`}
                    >
                      Iniciar Capacitación
                    </Link>
                  </div>
                  
                </div>
              </div>
            </li>
          
          ))}

        </ul>
      </div>
    </section>
  );
};

Render.contextTypes = {};

export default Render;



// WEBPACK FOOTER //
// ./src/pages/DesafiosPanel/Render.js